export const SUBMIT_UPTIME_BY_AGE_ACTION_REQUESTED = "SUBMIT_UPTIME_BY_AGE_ACTION_REQUESTED";
export const SUBMIT_UPTIME_BY_AGE_ACTION_DISPATCHER = "SUBMIT_UPTIME_BY_AGE_ACTION_DISPATCHER";
export const SUBMIT_UPTIME_BY_AGE_ERROR_DISPATCHER = "SUBMIT_UPTIME_BY_AGE_ERROR_DISPATCHER";
export const UPTIME_BY_AGE_LOADING = "UPTIME_BY_AGE_LOADING";

//Action Creator
export const submitUptimeByAgeAction = (data) => ({
  type: SUBMIT_UPTIME_BY_AGE_ACTION_REQUESTED,
  postData: data,
});

//Action Dispatcher
export const submitUptimeByAgeActionDispatcher = (data) => ({
  type: SUBMIT_UPTIME_BY_AGE_ACTION_DISPATCHER,
  payload: data,
});

export const submitUptimeByAgeErrorDispatcher = (data) => ({
  type: SUBMIT_UPTIME_BY_AGE_ERROR_DISPATCHER,
  payload: data,
});

export const uptimeByAgeLoading = (loading) => ({
  type: UPTIME_BY_AGE_LOADING,
  payload: loading,
});

